export function toFormatSum(value?: number | null | string): string {
  if (!value) {
    return '0';
  }
  if (typeof value === 'string') {
    value = +value;
  }
  if (isNaN(value)) {
    return '0';
  }
  return new Intl.NumberFormat('en-US').format(value);
}
